import Cookies from 'js-cookie';

const STORAGE_KEY = 'pacoca_device_id';
const COOKIE_KEY = 'pacoca_web_device_id';

const createId = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    }

    return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
};

const cookieOptions = (): Cookies.CookieAttributes => {
    const host = window.location.hostname;
    const sharedPacocaDomain = host === 'pacoca.net' || host.endsWith('.pacoca.net');

    return {
        secure: window.location.protocol === 'https:',
        sameSite: 'Strict',
        ...(sharedPacocaDomain ? { domain: '.pacoca.net' } : {}),
        expires: 365,
    };
};

const persistDeviceId = (deviceId: string) => {
    try {
        window.localStorage.setItem(STORAGE_KEY, deviceId);
    } catch {
        // Cookies still keep the browser identifier shared by the web frontends.
    }

    Cookies.set(COOKIE_KEY, deviceId, cookieOptions());
};

export const getDeviceId = (): string | null => {
    if (typeof window === 'undefined') return null;

    try {
        const sharedDeviceId = Cookies.get(COOKIE_KEY);
        if (sharedDeviceId) {
            persistDeviceId(sharedDeviceId);
            return sharedDeviceId;
        }

        const savedDeviceId = window.localStorage.getItem(STORAGE_KEY);
        if (savedDeviceId) {
            persistDeviceId(savedDeviceId);
            return savedDeviceId;
        }

        const deviceId = `web:${createId()}`;
        persistDeviceId(deviceId);
        return deviceId;
    } catch {
        return null;
    }
};
